/* eslint
    max-classes-per-file: "off",
    default-case: "warn",
    consistent-return: "warn",
    block-scoped-var: "warn",
    no-redeclare: "warn"
*/

import {
  EasyfyEventData,
  IDataMapper,
  IEasyfyEvent
} from '@shared/easyfy.events/easyfy.eventdata';
import { EventNames } from '@shared/easyfy.events/easyfy.eventhandler';

export class MedsEventNames {
  static LoginClick: string = 'loginclick';

  static LoggedIn: string = 'loggedin';

  static CustomerIdentified: string = 'customeridentifiedcheckout';

  static SetABTest: string = 'setabtest';

  static ProductVariantClick = 'productvariantclick';

  static AddToWishlist: string = 'addtowishlist';

  static MenuOpen: string = 'menuopen';

  static MenuCategorySelect: string = 'menucategoryselect';
}

export class WalleyEventNames {
  static Initialized = 'initialized';

  static InView = 'inview';

  static CustomerIdentified = 'customeridentified';

  static DeliveryAddressChanged = 'deliveryaddresschanged';

  static ShippingMethodSelected = 'shippingmethodselected';

  static PaymentCategorySelected = 'paymentcategoryselected';

  static PaymentMethodSelected = 'paymentmethodselected';

  static PaymentOptionSelected = 'paymentoptionselected';

  static CommittedToPurchase = 'committedtopurchase';

  static SCARequested = 'scarequested';

  static SCAStarted = 'scastarted';

  static SCACanceled = 'scacanceled';

  static KALPRequested = 'kalprequested';

  static KALPCanceled = 'kalpcanceled';

  static KALPSubmitted = 'kalpsubmitted';

  static PurchaseFailed = 'purchasefailed';

  static PurchaseCompleted = 'purchasecompleted';

  static CustomerFeedback = 'customerfeedback';
}

export interface ISearchPerformedData {
  searchString: string;
  source: string;
  productIdentifiers: any[];
  productHits: number;
  articleHits: number;
  brandHits: number;
  pageHits: number;
  totalProductResults: number;
  suggestions: any[];
}

/* Exporter class */
export class Ga4DataMapper implements IDataMapper {
  MapEventData(event: IEasyfyEvent): any {
    let mappedEvent: any;

    switch (event.eventName.toLowerCase()) {
      case EventNames.ProductImpression: {
        mappedEvent = this.ViewItemListEvent(event);
        break;
      }
      case EventNames.ProductClick: {
        mappedEvent = this.SelectItemEvent(event);
        break;
      }
      case EventNames.ProductPageView: {
        mappedEvent = this.ViewItemEvent(event);
        break;
      }
      case EventNames.BannerImpression: {
        mappedEvent = this.ViewPromotionEvent(event);
        break;
      }
      case EventNames.BannerClick: {
        mappedEvent = this.SelectPromotionEvent(event);
        break;
      }
      case EventNames.AddToCart: {
        mappedEvent = this.AddToCartEvent(event);
        break;
      }
      case EventNames.RemoveFromCart: {
        mappedEvent = this.RemoveFromCartEvent(event);
        break;
      }
      case EventNames.StartedCheckout: {
        mappedEvent = this.StartedCheckoutEvent(event);
        break;
      }
      case MedsEventNames.LoginClick: {
        mappedEvent = this.LoginClick(event);
        break;
      }
      case MedsEventNames.LoggedIn: {
        mappedEvent = this.LoggedIn(event);
        break;
      }
      case EventNames.SearchPerformed: {
        mappedEvent = this.SearchPerformed(event);
        break;
      }
      case EventNames.ContinueToPayment: {
        mappedEvent = this.ContinueToPayment(event);
        break;
      }
      case MedsEventNames.CustomerIdentified: {
        mappedEvent = this.CustomerIdentified(event);
        break;
      }
      case MedsEventNames.SetABTest: {
        mappedEvent = this.UserABTest(event);
        break;
      }
      case MedsEventNames.ProductVariantClick: {
        mappedEvent = this.SelectVariantItemEvent(event);
        break;
      }
      case MedsEventNames.AddToWishlist: {
        mappedEvent = this.AddToWishList(event);
        break;
      }
      case MedsEventNames.MenuOpen: {
        mappedEvent = this.MenuOpen(event);
        break;
      }
      case MedsEventNames.MenuCategorySelect: {
        mappedEvent = this.MenuCategorySelect(event);
        break;
      }
      case WalleyEventNames.CommittedToPurchase:
      case WalleyEventNames.CustomerIdentified:
      case WalleyEventNames.DeliveryAddressChanged:
      case WalleyEventNames.Initialized:
      case WalleyEventNames.InView:
      case WalleyEventNames.KALPCanceled:
      case WalleyEventNames.KALPRequested:
      case WalleyEventNames.KALPSubmitted:
      case WalleyEventNames.PurchaseCompleted:
      case WalleyEventNames.PurchaseFailed:
      case WalleyEventNames.SCACanceled:
      case WalleyEventNames.SCARequested:
      case WalleyEventNames.SCAStarted:
      case WalleyEventNames.ShippingMethodSelected: {
        mappedEvent = this.GenericWalleyCheckoutEvent(event);
        break;
      }
      case WalleyEventNames.PaymentMethodSelected: {
        mappedEvent = this.WalleyPaymentMethodSelected(event);
        break;
      }
      case WalleyEventNames.PaymentCategorySelected: {
        mappedEvent = this.WalleyPaymentCategorySelected(event);
        break;
      }
      case WalleyEventNames.PaymentOptionSelected: {
        mappedEvent = this.WalleyPaymentOptionSelected(event);
        break;
      }
      case WalleyEventNames.CustomerFeedback: {
        mappedEvent = this.WalleyCustomerFeedback(event);
        break;
      }
      default: {
        console.warn(`Event ${event.eventName} is not mapped to GA4.`);
      }
    }

    return mappedEvent;
  }

  ViewItemListEvent(event: IEasyfyEvent): any {
    if (!event.data.productIdentifiers) {
      return;
    }
    const eventProducts = EasyfyEventData.Products(
      event.data.productIdentifiers
    );
    if (!eventProducts || eventProducts.length === 0) {
      return;
    }

    const siteInfo = EasyfyEventData.SiteInfo();
    const ga4items: any[] = [];

    eventProducts.forEach((product, index) => {
      const productListIndex =
        EasyfyEventData.ProductIndexInList(
          event.data.listIds[index],
          product.Id
        ) + 1;

      ga4items.push({
        discount: null,
        variant: null,
        coupon: null,
        price: product.PriceExVat,
        index: productListIndex,
        item_list_name: event.data.listIds[index],
        item_variant: null,
        item_id: product.Id,
        item_name: product.DisplayName,
        item_brand: product.Brand,
        item_category:
          product.Categories.length > 0 ? product.Categories[0] : null,
        item_category2:
          product.Categories.length > 1 ? product.Categories[1] : null,
        item_category3:
          product.Categories.length > 2 ? product.Categories[2] : null,
        item_category4:
          product.Categories.length > 3 ? product.Categories[3] : null,
        item_category5:
          product.Categories.length > 4 ? product.Categories[4] : null,
        quantity: 1,
        cd_campaign_code: product.CampaignCode,
        sponsorship_id: product.SponsorshipId
      });
    });

    const gaEvent = {
      event: 'view_item_list',
      ecommerce: {
        currency: siteInfo.currencyCode,
        items: ga4items
      }
    };

    return gaEvent;
  }

  SelectItemEvent(event: IEasyfyEvent): any {
    if (!event.data.productIdentifier) {
      return;
    }

    const product = EasyfyEventData.Product(event.data.productIdentifier);
    const productListIndex = EasyfyEventData.ProductIndexInList(
      event.data.listName,
      product.Id
    );
    const siteInfo = EasyfyEventData.SiteInfo();
    const ga4items: any[] = [];

    ga4items.push({
      discount: null,
      variant: null,
      coupon: null,
      price: product.PriceExVat,
      index: productListIndex + 1,
      item_list_name: event.data.listName,
      item_variant: null,
      item_id: product.Id,
      item_name: product.DisplayName,
      item_brand: product.Brand,
      item_category:
        product.Categories.length > 0 ? product.Categories[0] : null,
      item_category2:
        product.Categories.length > 1 ? product.Categories[1] : null,
      item_category3:
        product.Categories.length > 2 ? product.Categories[2] : null,
      item_category4:
        product.Categories.length > 3 ? product.Categories[3] : null,
      item_category5:
        product.Categories.length > 4 ? product.Categories[4] : null,
      quantity: 1,
      cd_campaign_code: product.CampaignCode,
      sponsorship_id: product.SponsorshipId
    });

    const gaEvent = {
      event: 'select_item',
      ecommerce: {
        currency: siteInfo.currencyCode,
        items: ga4items
      }
    };

    return gaEvent;
  }

  ViewItemEvent(event: IEasyfyEvent): any {
    if (!event.data.productIdentifier) {
      return;
    }

    const product = EasyfyEventData.Product(event.data.productIdentifier);
    const siteInfo = EasyfyEventData.SiteInfo();
    const ga4items: any[] = [];

    ga4items.push({
      discount: null,
      variant: null,
      coupon: null,
      price: product.PriceExVat,
      index: null,
      item_list_name: null,
      item_variant: null,
      item_id: product.Id,
      item_name: product.DisplayName,
      item_brand: product.Brand,
      item_category:
        product.Categories.length > 0 ? product.Categories[0] : null,
      item_category2:
        product.Categories.length > 1 ? product.Categories[1] : null,
      item_category3:
        product.Categories.length > 2 ? product.Categories[2] : null,
      item_category4:
        product.Categories.length > 3 ? product.Categories[3] : null,
      item_category5:
        product.Categories.length > 4 ? product.Categories[4] : null,
      quantity: 1,
      cd_campaign_code: product.CampaignCode
    });

    const gaEvent = {
      event: 'view_item',
      ecommerce: {
        currency: siteInfo.currencyCode,
        value: product.PriceExVat,
        items: ga4items
      }
    };

    return gaEvent;
  }

  ViewPromotionEvent(event: IEasyfyEvent): any {
    if (!event.data.bannerIdentifier) {
      return;
    }

    const banner = EasyfyEventData.Banner(event.data.bannerIdentifier);
    if (!banner) {
      return;
    }
    const ga4items: any[] = [];

    ga4items.push({
      promotion_id: banner.Id,
      promotion_name: banner.DisplayName,
      quantity: 1,
      cd_linkUrl: banner.LinkUrl,
      cd_pageUrl: banner.PageUrl,
      creative_name: null,
      creative_slot: null,
      discount: null,
      coupon: null,
      price: null,
      item_list_name: null,
      item_variant: null,
      item_id: null,
      item_name: null,
      item_brand: null,
      item_category: null,
      item_category2: null,
      item_category3: null,
      item_category4: null,
      item_category5: null
    });

    const gaEvent = {
      event: 'view_promotion',
      ecommerce: {
        items: ga4items
      }
    };

    return gaEvent;
  }

  SelectPromotionEvent(event: IEasyfyEvent): any {
    if (!event.data.bannerIdentifier) {
      return;
    }

    const banner = EasyfyEventData.Banner(event.data.bannerIdentifier);
    if (!banner) {
      return;
    }
    const ga4items: any[] = [];

    ga4items.push({
      promotion_id: banner.Id,
      promotion_name: banner.DisplayName,
      quantity: 1,
      cd_linkUrl: banner.LinkUrl,
      cd_pageUrl: banner.PageUrl,
      creative_name: null,
      creative_slot: null,
      discount: null,
      coupon: null,
      price: null,
      item_list_name: null,
      item_variant: null,
      item_id: null,
      item_name: null,
      item_brand: null,
      item_category: null,
      item_category2: null,
      item_category3: null,
      item_category4: null,
      item_category5: null
    });

    const gaEvent = {
      event: 'select_promotion',
      ecommerce: {
        items: ga4items
      }
    };

    return gaEvent;
  }

  AddToCartEvent(event: IEasyfyEvent): any {
    if (!event.data.productIdentifier) {
      return;
    }

    const product = EasyfyEventData.Product(event.data.productIdentifier);
    const siteInfo = EasyfyEventData.SiteInfo();
    const ga4items: any[] = [];

    const { referredListName, referredSponsorshipId } = this.GetReferredTrackingData(event.data.productIdentifier);

    ga4items.push({
      discount: null,
      variant: null,
      coupon: null,
      price: product.PriceExVat,
      index: null,
      item_list_name: event.data.listName,
      item_variant: null,
      item_id: product.Id,
      item_name: product.DisplayName,
      item_brand: product.Brand,
      item_category:
        product.Categories.length > 0 ? product.Categories[0] : null,
      item_category2:
        product.Categories.length > 1 ? product.Categories[1] : null,
      item_category3:
        product.Categories.length > 2 ? product.Categories[2] : null,
      item_category4:
        product.Categories.length > 3 ? product.Categories[3] : null,
      item_category5:
        product.Categories.length > 4 ? product.Categories[4] : null,
      quantity: event.data.quantity,
      cd_campaign_code: product.CampaignCode,
      referred_list_name: referredListName,
      sponsorship_id: product.SponsorshipId,
      referred_sponsorship_id: referredSponsorshipId
    });

    const gaEvent = {
      event: 'add_to_cart',
      ecommerce: {
        currency: siteInfo.currencyCode,
        value: product.PriceExVat * event.data.quantity,
        items: ga4items
      }
    };

    return gaEvent;
  }

  GetReferredTrackingData(productIdentifier: string): { referredListName: string | null; referredSponsorshipId: string | null } {
    const productElement = document.querySelector(
      '[data-container="product-actions"]'
    )?.querySelector(
      `[data-product-sku="${productIdentifier}"]`
    );

    return {
      referredListName: productElement?.getAttribute("data-referred-list-name") ?? null,
      referredSponsorshipId: productElement?.getAttribute("data-referred-sponsorship-id") ?? null
    };
  }

  RemoveFromCartEvent(event: IEasyfyEvent): any {
    if (!event.data.productIdentifier) {
      return;
    }

    const product = EasyfyEventData.Product(event.data.productIdentifier);
    const siteInfo = EasyfyEventData.SiteInfo();
    const ga4items: any[] = [];

    ga4items.push({
      discount: null,
      variant: null,
      coupon: null,
      price: product.PriceExVat,
      index: null,
      item_list_name: event.data.listName,
      item_variant: null,
      item_id: product.Id,
      item_name: product.DisplayName,
      item_brand: product.Brand,
      item_category:
        product.Categories.length > 0 ? product.Categories[0] : null,
      item_category2:
        product.Categories.length > 1 ? product.Categories[1] : null,
      item_category3:
        product.Categories.length > 2 ? product.Categories[2] : null,
      item_category4:
        product.Categories.length > 3 ? product.Categories[3] : null,
      item_category5:
        product.Categories.length > 4 ? product.Categories[4] : null,
      quantity: event.data.quantity,
      cd_campaign_code: product.CampaignCode
    });

    const gaEvent = {
      event: 'remove_from_cart',
      ecommerce: {
        value: product.PriceExVat * event.data.quantity,
        currency: siteInfo.currencyCode,
        items: ga4items
      }
    };

    return gaEvent;
  }

  StartedCheckoutEvent(event: IEasyfyEvent): any {
    if (
      !event.data.checkoutProducts ||
      event.data.checkoutProducts.length === 0
    ) {
      return;
    }
    const ga4items: any[] = [];
    const siteInfo = EasyfyEventData.SiteInfo();
    let value: number = 0;

    event.data.checkoutProducts.forEach((checkoutProduct) => {
      const product = EasyfyEventData.Product(
        checkoutProduct.productIdentifier
      );

      ga4items.push({
        discount: null,
        variant: null,
        coupon: null,
        price: product.PriceExVat,
        index: null,
        item_list_name: null,
        item_variant: null,
        item_id: product.Id,
        item_name: product.DisplayName,
        item_brand: product.Brand,
        item_category:
          product.Categories.length > 0 ? product.Categories[0] : null,
        item_category2:
          product.Categories.length > 1 ? product.Categories[1] : null,
        item_category3:
          product.Categories.length > 2 ? product.Categories[2] : null,
        item_category4:
          product.Categories.length > 3 ? product.Categories[3] : null,
        item_category5:
          product.Categories.length > 4 ? product.Categories[4] : null,
        quantity: checkoutProduct.qty,
        cd_campaign_code: product.CampaignCode
      });

      value += product.PriceExVat * checkoutProduct.qty;
    });

    const gaEvent = {
      event: 'begin_checkout',
      ecommerce: {
        currency: siteInfo.currencyCode,
        value,
        items: ga4items
      }
    };

    return gaEvent;
  }

  LoginClick(event: IEasyfyEvent): any {
    const gaEvent = {
      event: 'login_click'
    };
    return gaEvent;
  }

  LoggedIn(event: IEasyfyEvent): any {
    const gaEvent = {
      event: 'logged_in'
    };
    return gaEvent;
  }

  UserABTest(event: IEasyfyEvent): any {
    if (!event.data.abTest) {
      return;
    }

    const gaEvent = {
      event: 'set_abtest',
      ab_test: event.data.abTest
    };
    return gaEvent;
  }

  SearchPerformed(event: IEasyfyEvent): any {
    if (!event.data) {
      return;
    }

    const data = event.data as ISearchPerformedData;
    let gaEvent;
    const hasNoProductHits = data.productHits === 0;
    const hasSuggestions = data.suggestions?.length > 0;

    if (hasNoProductHits || hasSuggestions) {
      gaEvent = {
        event: 'search_no_hit',
        search_term: data.searchString,
        source: data.source,
        product_hits: data.productHits,
        article_hits: data.articleHits,
        page_hits: data.pageHits,
        brand_hits: data.brandHits,
        total_product_results: data.totalProductResults,
        suggestions: data.suggestions,
        product_ids: data.productIdentifiers
      };
    } else {
      gaEvent = {
        event: 'search_hit',
        search_term: data.searchString,
        source: data.source,
        product_hits: data.productHits,
        article_hits: data.articleHits,
        page_hits: data.pageHits,
        brand_hits: data.brandHits,
        total_product_results: data.totalProductResults,
        suggestions: data.suggestions,
        product_ids: data.productIdentifiers
      };
    }

    return gaEvent;
  }

  ContinueToPayment(event: IEasyfyEvent): any {
    const paymentInitialized: string =
      sessionStorage.getItem('paymentinitialized');

    if (
      !event.data.checkoutProducts ||
      event.data.checkoutProducts.length === 0 ||
      paymentInitialized != null
    ) {
      return;
    }
    const ga4items: any[] = [];
    const siteInfo = EasyfyEventData.SiteInfo();
    let value: number = 0;

    event.data.checkoutProducts.forEach((checkoutProduct) => {
      const product = EasyfyEventData.Product(
        checkoutProduct.productIdentifier
      );

      ga4items.push({
        discount: null,
        variant: null,
        coupon: null,
        price: product.PriceExVat,
        index: null,
        item_list_name: null,
        item_variant: null,
        item_id: product.Id,
        item_name: product.DisplayName,
        item_brand: product.Brand,
        item_category:
          product.Categories.length > 0 ? product.Categories[0] : null,
        item_category2:
          product.Categories.length > 1 ? product.Categories[1] : null,
        item_category3:
          product.Categories.length > 2 ? product.Categories[2] : null,
        item_category4:
          product.Categories.length > 3 ? product.Categories[3] : null,
        item_category5:
          product.Categories.length > 4 ? product.Categories[4] : null,
        quantity: checkoutProduct.qty,
        cd_campaign_code: product.CampaignCode
      });

      value += product.PriceExVat * checkoutProduct.qty;
    });

    const gaEvent = {
      event: 'continue_to_payment',
      ecommerce: {
        currency: siteInfo.currencyCode,
        value,
        items: ga4items
      }
    };

    sessionStorage.setItem('paymentinitialized', 'true');

    return gaEvent;
  }

  CustomerIdentified(event: IEasyfyEvent): any {
    const customerIdentified = sessionStorage.getItem('customeridentified');

    if (
      !event.data.checkoutProducts ||
      event.data.checkoutProducts.length === 0 ||
      customerIdentified != null
    ) {
      return;
    }
    const ga4items: any[] = [];
    const siteInfo = EasyfyEventData.SiteInfo();
    let value: number = 0;

    event.data.checkoutProducts.forEach((checkoutProduct) => {
      const product = EasyfyEventData.Product(
        checkoutProduct.productIdentifier
      );

      ga4items.push({
        discount: null,
        variant: null,
        coupon: null,
        price: product.PriceExVat,
        index: null,
        item_list_name: null,
        item_variant: null,
        item_id: product.Id,
        item_name: product.DisplayName,
        item_brand: product.Brand,
        item_category:
          product.Categories.length > 0 ? product.Categories[0] : null,
        item_category2:
          product.Categories.length > 1 ? product.Categories[1] : null,
        item_category3:
          product.Categories.length > 2 ? product.Categories[2] : null,
        item_category4:
          product.Categories.length > 3 ? product.Categories[3] : null,
        item_category5:
          product.Categories.length > 4 ? product.Categories[4] : null,
        quantity: checkoutProduct.qty,
        cd_campaign_code: product.CampaignCode
      });

      value += product.PriceExVat * checkoutProduct.qty;
    });

    const gaEvent = {
      event: 'customer_identified',
      ecommerce: {
        currency: siteInfo.currencyCode,
        value,
        items: ga4items
      }
    };

    sessionStorage.setItem('customeridentified', 'true');

    return gaEvent;
  }

  SelectVariantItemEvent(event: IEasyfyEvent): any {
    if (!event.data.productId) {
      return;
    }

    const gaEvent = {
      event: 'select_variant_item',
      price: event.data.productPrice,
      product_id: event.data.productId,
      variant: event.data.productRelationValue,
      url: event.data.productUrl
    };

    return gaEvent;
  }

  AddToWishList(event: IEasyfyEvent): any {
    if (!event.data.productIdentifier) {
      return;
    }

    const product = EasyfyEventData.Product(event.data.productIdentifier);
    const siteInfo = EasyfyEventData.SiteInfo();
    const ga4items: any[] = [];

    ga4items.push({
      discount: null,
      variant: null,
      coupon: null,
      price: product.PriceExVat,
      index: null,
      item_list_name: null,
      item_variant: null,
      item_id: product.Id,
      item_name: product.DisplayName,
      item_brand: product.Brand,
      item_category:
        product.Categories.length > 0 ? product.Categories[0] : null,
      item_category2:
        product.Categories.length > 1 ? product.Categories[1] : null,
      item_category3:
        product.Categories.length > 2 ? product.Categories[2] : null,
      item_category4:
        product.Categories.length > 3 ? product.Categories[3] : null,
      item_category5:
        product.Categories.length > 4 ? product.Categories[4] : null,
      quantity: event.data.quantity,
    });

    const gaEvent = {
      event: 'add_to_wishlist',
      ecommerce: {
        currency: siteInfo.currencyCode,
        value: product.PriceExVat * event.data.quantity,
        items: ga4items
      }
    };

    return gaEvent;
  }

  MenuOpen(event: IEasyfyEvent): any {
    const gaEvent = {
      event: 'menu_open'
    };

    return gaEvent;
  }

  MenuCategorySelect(event: IEasyfyEvent): any {
    const gaEvent = {
      event: 'menu_category_select',
      category: event.data.category,
      action: event.data.action
    };

    return gaEvent;
  }

  FormatWalleyEventName(eventName: string) {
    return `walley_${eventName.toLowerCase()}`;
  }

  GenericWalleyCheckoutEvent(checkoutEvent: IEasyfyEvent) {
    const gaEvent = {
      event: this.FormatWalleyEventName(checkoutEvent.eventName)
    };

    return gaEvent;
  }

  WalleyCustomerFeedback(checkoutEvent: IEasyfyEvent) {
    const gaEvent = {
      event: this.FormatWalleyEventName(checkoutEvent.eventName),
      ecommerce: {
        customer_satisfied: checkoutEvent.data.customerSatisfied
      }
    };

    return gaEvent;
  }

  WalleyPaymentCategorySelected(checkoutEvent: IEasyfyEvent) {
    const gaEvent = {
      event: this.FormatWalleyEventName(checkoutEvent.eventName),
      ecommerce: {
        category: checkoutEvent.data.category
      }
    };

    return gaEvent;
  }

  WalleyPaymentMethodSelected(checkoutEvent: IEasyfyEvent) {
    const gaEvent = {
      event: this.FormatWalleyEventName(checkoutEvent.eventName),
      ecommerce: {
        payment_method: checkoutEvent.data.paymentMethod
      }
    };

    return gaEvent;
  }

  WalleyPaymentOptionSelected(checkoutEvent: IEasyfyEvent) {
    const gaEvent = {
      event: this.FormatWalleyEventName(checkoutEvent.eventName),
      ecommerce: {
        payment_option: {
          payment_method_name: checkoutEvent.data.paymentOption.paymentMethodName,
          payment_option_id: checkoutEvent.data.paymentOption.paymentOptionId
        }
      }
    };

    return gaEvent;
  }
}
